import type { Nullable } from '../../../typescript'
import findByIdOrThrow from '../findByIdOrThrow'
import type { MoveTypeId } from './move_type_id.enum'
import type { MoveTypeMeta } from './MoveTypeMeta.type'
import moveTypeMetaList from './moveTypeMetaList'

export default function getMoveTypeMetaById(moveTypeId: MoveTypeId): Nullable<MoveTypeMeta> {
  return findByIdOrThrow(moveTypeMetaList, moveTypeId)
}
